import React, {useState, useEffect} from 'react';

import { Select, notification, Form, message } from 'antd';

import _service from '@netuno/service-client';

import { FormattedMessage, useIntl } from "react-intl";

const langContext = 'components.language-select';

export default (props) => {
  const intl = useIntl();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(()=> {
    setLoading(true); 
    _service({
      url: "/language/list",
      success: (response) => {
        setLoading(false);
        setData(response.json);
      },
      fail: (e) => {
        notification["error"]({
          message: intl.formatMessage({id: `${langContext}.error.message`}),
          description: e.response.json.error,
        });
      }
    });
  }, []);
  return (
    <Select placeholder={intl.formatMessage({id: `${langContext}.placeholder`})} style={{width: '100%'}} loading={loading} {...props}>
      {
        data.map((item, key) => (
          <Select.Option key={key} value={item.code}>
            {item.description}
          </Select.Option>
        ))
      }
    </Select>
  );
};

